import React from "react";
import { ArrowCounterClockwiseIcon, LockIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme";
import { Alert, Button, Col, ConfigProvider, Flex, Typography } from "antd";
import { ProjectType } from "../types";
import { isProjectFlash } from "../helpers/helper";
import { radius } from "@libertify/ui";

interface ProjectUnpublishProps {
  onUnpublish?: () => void;
  isMutating?: boolean;
  projectType?: ProjectType;
}

const ProjectUnpublish: React.FC<ProjectUnpublishProps> = ({
  onUnpublish,
  isMutating,
  projectType,
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  const isFlashProject = isProjectFlash(projectType);
  const bannerText = isFlashProject
    ? t("media.components.ProjectUnpublish.unpublishBannerFlash")
    : t("media.components.ProjectUnpublish.unpublishBannerCustom");

  const alertStyles = {
    container: {
      borderRadius: radius.box,
      padding: "12px 20px",
      marginBottom: "25px",
    },
    icon: {
      color: theme.colorInfo,
      minWidth: 20,
      fontSize: "14px",
    },
    message: {
      color: theme.colorInfo,
      fontSize: "14px",
    },
  };

  return (
    <Alert
      type="info"
      style={alertStyles.container}
      message={
        <Flex align="center" justify="space-between" gap={16} wrap="wrap">
          <Col style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <LockIcon size={20} style={alertStyles.icon} />
            <Typography.Text style={alertStyles.message}>
              {bannerText}
            </Typography.Text>
          </Col>
          <Col>
            <ConfigProvider
              theme={{
                token: { colorPrimary: theme.colorInfo },
              }}
            >
              <Button
                type="primary"
                icon={<ArrowCounterClockwiseIcon />}
                onClick={onUnpublish}
                shape="round"
                style={{ fontSize: "16px" }}
                loading={isMutating}
                disabled={isMutating}
              >
                {t("media.components.ProjectUnpublish.unpublishButton")}
              </Button>
            </ConfigProvider>
          </Col>
        </Flex>
      }
    />
  );
};

export default ProjectUnpublish;
